export enum LogLevelsDictionary {
  warning = 'WARNING',
  debug = 'DEBUG',
  error = 'ERROR',
  info = 'INFO'
}
